"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KBA_TERMINAL_STATUSES = exports.KbaStatus = void 0;
// Keep all the values in this enum <16 chars long to avoid issues with the database
var KbaStatus;
(function (KbaStatus) {
    KbaStatus["incomplete"] = "incomplete";
    KbaStatus["pass"] = "pass";
    KbaStatus["passWithQuestions"] = "passWithQuestions";
    KbaStatus["failAllowRetry"] = "failAllowRetry";
    KbaStatus["failNoRetry"] = "failNoRetry";
    KbaStatus["failNoRetrySsn"] = "failNoRetrySsn";
    KbaStatus["noQuestions"] = "noQuestions";
})(KbaStatus || (exports.KbaStatus = KbaStatus = {}));
exports.KBA_TERMINAL_STATUSES = [KbaStatus.pass, KbaStatus.passWithQuestions, KbaStatus.failNoRetry, KbaStatus.failNoRetrySsn];
